






































































































































import { namespace } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';
import Select from '@/shared/components/Inputs/Select.vue';

import { BankAccount, banks } from '@/entities/Bank';
import { Payment } from '@/classes/Checkout/Payment';

import { EPaymentMethod } from '@/helpers/enums';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Input,
    Field,
    Select,
    ValidationObserver,
    ValidationProvider,
  }
})
export default class WireTransferForm extends Vue {
  public $refs!: {
    observer: any,
  };

  private value: any = new BankAccount();

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  @CheckoutModule.Getter('selectedOfferDiscountByPaymentMethod')
  private discountByPaymentMethod: any;

  @Watch('value', { deep: true })
  onValueChange (value: any) {
    this.payment.setBankAccount(value);
  }

  private get banks () {
    return banks.map((bank: any) => ({
      ...bank,
      text: `${bank.code} - ${this.$t(`App.Checkout.Payment.banks.${bank.bank}`)}`,
      value: bank.code,
    }));
  }

  private hasAnyError (errors: any) {
    return Object.entries(errors).some((e: any) => e[1].length);
  }

  public async validateForm() {
    return await this.$refs.observer.validate();
  }

  private get labelDiscount() {
    return this.$t(`App.Checkout.Payment.discount.paymentsMethods.${EPaymentMethod.wireTransfer}`);
  }

  private get showLabelDiscount() {
    return this.discountByPaymentMethod(EPaymentMethod.wireTransfer);
  }
}
